module.exports = __webpack_public_path__ + "img/stopwatch.dd1b07e7.png";